import { phoenixBase } from '@/utils/gateway';

export const API_BASE_URL = `${phoenixBase()}/api`;
